import { AllHTMLAttributes, ReactNode } from "react";
import styles from "./card-body.module.css";

export type CardBodyProps = {
  children: ReactNode;
} & AllHTMLAttributes<HTMLDivElement>;

export function CardBody({ children, ...props }: CardBodyProps) {
  return (
    <div className={styles.Body} {...props}>
      {children}
    </div>
  );
}
